import { batchedServicePost } from "./readBatch.ts";
import type { ReturnObject } from "../types/returnObject.ts";

/* ── Types ─────────────────────────────────────────────── */

export interface UpsStatusData {
  iKioskID: number;
  bHasPower: number;    // 1 = has power, 0 = no power
  dKioskDate: string;
  sBatteryLevel: string;
}

/* ── API ───────────────────────────────────────────────── */

export function getUpsStatus(startDate: string, endDate: string, kioskIds: number[]): Promise<ReturnObject<UpsStatusData[]>> {
  return batchedServicePost<UpsStatusData[]>("GetUpsStatus", {
    startDate,
    endDate,
    kioskIds,
  });
}
